import { AloftPrice } from '@aloft/toolkit-shared';

import { SummaryTableBoldDivider } from '../SummaryTableBoldDivider.js';
import { CostApproachSummaryRollupRow } from './CostApproachSummaryRollupRow.js';

export const CostApproachSummaryIndicatedValue = ({
  indicatedValue,
}: {
  indicatedValue?: AloftPrice;
}) => (
  <>
    <SummaryTableBoldDivider />
    <CostApproachSummaryRollupRow
      label="= Indicated value by the cost 
        approach"
      value={indicatedValue ? `= ${indicatedValue?.toString(true)}` : ''}
    />
  </>
);
